import 'javascripts/all_pages.js'
import { jqUrlUtils, jqTextExpander } from 'javascripts/general_scripts'

/* stylesheet */
if($('#landingpages2-provide_review').length) {
  import('javascripts/all_theme_styles.js')
} else {
  import('javascripts/all_pages_styles.js')
  import('stylesheets/landingpages2/default_styles.less')
}

jqTextExpander();
$('.full-review').expander(13);

jQuery(() => {
  jqUrlUtils();
  $('[name="product_review_rating"]').change(function() {
    var rating = $('[name="product_review_rating"]:checked').val();
    var element = $("#save-review-button");
    var attr_name = (element.attr('data-after_signin_redirect') === undefined) ? 'href' : 'data-after_signin_redirect'; // The attribute name depends if the user is logged in or not
    element.attr(attr_name, $.replSearchParams({ url: element.attr(attr_name), paramsObj: { rating }})); //Replace current rating param with newly checked param
  });
});